<h2 mat-dialog-title>{{ isNew ? "Tambah" : "Ubah" }} Regulasi</h2>
<mat-dialog-content class="mat-typography">
    <form class="form-container" name="form" (ngSubmit)="f.form.valid && onSubmit()" #f="ngForm" novalidate>
        <p>
            <mat-form-field appearance="outline">
                <mat-label>Judul</mat-label>
                <input matInput placeholder="Judul Regulasi" [formControl]="title" required />
                <mat-error *ngIf="title.invalid">{{
                    getTitleErrorMessage()
                    }}</mat-error>
            </mat-form-field>
        </p>
        <p>
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Kategori</mat-label>
                <mat-select [formControl]="category" (selectionChange)="onCategorySelection($event)" required>
                    <mat-option *ngFor="let category of categories" [value]="category.id">
                        {{ category.name }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="category.invalid">{{
                    getCategoryErrorMessage()
                    }}</mat-error>
            </mat-form-field>
        </p>
        <p *ngIf="!isNew" class="filename">
            File yang sudah diupload :
            <button mat-icon-button type="button" (click)="downloadFile()">
                <mat-icon mat-list-icon>cloud_download</mat-icon> {{ data.filename }}
            </button>
        </p>
        <p>
            <mat-form-field class="full-width" appearance="outline">
                <div>
                    <mat-toolbar>
                        <!-- Display files names -->
                        <input matInput [(ngModel)]="fileAttr" readonly name="name" />

                        <button mat-flat-button color="primary" class="upload-btn">
                            Pilih Berkas
                        </button>
                    </mat-toolbar>

                    <input type="file" #fileInput id="uploadFile" (change)="uploadFileEvt($event)" name="uploadFile"
                        multiple="multiple" accept=".pdf" />
                </div>
            </mat-form-field>
        </p>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close *ngIf="!isLoading">Batal</button>
    <button mat-button cdkFocusInitial *ngIf="!isLoading" (click)="f.form.valid && onSubmit()">
        Simpan
    </button>
    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
</mat-dialog-actions>